import classNames from "classnames";
import React, { ReactHTML } from "react";

import { COLOR_LOOKUP } from "lib/colors";

export type TextComponentProps = {
    className?: string;
    baseClassName?: string;
    color?: string;
} & React.HTMLAttributes<HTMLElement>;

type TextProps = {
    element: keyof ReactHTML;
} & TextComponentProps;

const Text = React.forwardRef<HTMLElement, TextProps>(
    ({ element, baseClassName, className, color = "", ...props }, ref) =>
        React.createElement(element, {
            className: classNames(baseClassName, className, {
                [`color-${COLOR_LOOKUP[color]}`]: color,
            }),
            ref,
            ...props,
        }),
);

// Component builder which ensures we forward refs for easier use within things like MUI Tooltips
const createTextComponent = (baseClassName: string, element: keyof ReactHTML) =>
    React.forwardRef<HTMLElement, TextComponentProps>((props, ref) => (
        <Text ref={ref} {...props} baseClassName={baseClassName} element={element} />
    ));

export const H3 = createTextComponent("h3", "h3");
export const H4 = createTextComponent("h4", "h4");
export const H5 = createTextComponent("h5", "h5");
export const H6 = createTextComponent("h6", "h6");

export const Subtitle1 = createTextComponent("text-subtitle1", "div");
export const Subtitle2 = createTextComponent("text-subtitle2", "div");
export const Body1 = createTextComponent("text-body1", "div");
export const Body2 = createTextComponent("text-body2", "div");
export const Caption = createTextComponent("text-caption", "div");
export const Overline = createTextComponent("text-overline", "div");
export const Bold = createTextComponent("text-bold", "b");

export const InlineSubtitle1 = createTextComponent("text-subtitle1", "span");
export const InlineSubtitle2 = createTextComponent("text-subtitle2", "span");
export const InlineBody1 = createTextComponent("text-body1", "span");
export const InlineBody2 = createTextComponent("text-body2", "span");
export const InlineCaption = createTextComponent("text-caption", "span");
export const InlineOverline = createTextComponent("text-overline", "span");
